import React from 'react';

export default class NoteDisplayNames extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {

		var beats = [];

		for (var i = 0; i < this.props.names.length; i++) {
			beats.push(
				<div key={i} className="note">{this.props.names[i]}</div>
			);
		}

		return (
			<div className="NoteDisplayName">
				{beats}
			</div>
		);
	}
}
